import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=7bdf66c8&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=7bdf66c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf66c8",
  null
  
)

export default component.exports